import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/data/content";
import { Eyebrow } from "./Ornaments";
import { Reveal, scrollToId } from "./Reveal";

const Card = ({ c, i, onPick }) => (
  <motion.button
    type="button"
    onClick={() => onPick(c.title)}
    data-testid={`category-card-${c.id}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className={`group relative text-left rounded-[28px] overflow-hidden p-3 h-[340px] md:h-auto flex flex-col ${c.span}`}
    style={{ backgroundColor: c.tint }}
  >
    <div className="relative flex-1 rounded-[20px] overflow-hidden min-h-0">
      <img src={c.img} alt={c.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.07]" />
      <span className="absolute top-3 left-3 rounded-full bg-cream/90 backdrop-blur px-3 py-1.5 text-xs font-semibold text-ink">{c.tag}</span>
      <span className="absolute top-3 right-3 w-10 h-10 rounded-full bg-cream flex items-center justify-center text-ink transition-transform duration-500 group-hover:rotate-45 group-hover:bg-pink">
        <ArrowUpRight size={18} />
      </span>
    </div>
    <div className="px-2 pt-4 pb-1">
      <h3 className="font-display text-2xl text-ink">{c.title}</h3>
      <p className="text-sm text-muted-ink mt-1 leading-relaxed line-clamp-2">{c.desc}</p>
      <span data-testid={`category-enquire-${c.id}`} className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-terra-deep transition-transform duration-500 group-hover:translate-x-1">
        Enquire now <ArrowUpRight size={15} />
      </span>
    </div>
  </motion.button>
);

export const Categories = ({ onPick }) => {
  const pick = (title) => { onPick(title); scrollToId("enquiry"); };
  return (
    <section id="occasions" data-testid="categories-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-6 items-end mb-14">
          <Reveal className="lg:col-span-7">
            <Eyebrow>Occasions we celebrate</Eyebrow>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ink mt-5 leading-[1.05]">
              Six kinds of joy, <span className="italic text-terra">one trusted team.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <p className="text-base md:text-lg text-muted-ink leading-relaxed">From the first haldi to a grand Bhagwat Katha, we bring the same care, clear budgets and calm execution. Tap any occasion to start planning.</p>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 md:auto-rows-[280px] gap-4 sm:gap-5">
          {CATEGORIES.map((c, i) => <Card key={c.id} c={c} i={i} onPick={pick} />)}
        </div>
      </div>
    </section>
  );
};
